import {useGenericQuery} from '../../../core/api/reactQuery';
import {getLessonDetails} from "../queries/lesson";
import {useLessonContentStore} from "../stores/lessonContentStore";

export function useContentLesson(slug: string, isFree: boolean) {
  const {setLesson} = useLessonContentStore()

  const {
    data,
    isError,
    error,
    isSuccess,
    isPending
  } = useGenericQuery(['lesson', slug, isFree], () => getLessonDetails(slug, isFree), setLesson);

    return {
        data,
        isError,
        isLoading: isPending,
        error,
        isSuccess,
    }
}
